/**
 * created by xcc
 *维护字段
 */
import React from "react";
import {
    Button,
    Icon,
    Input,
    Switch,
    Modal,
    Popconfirm,
    Form,
    Select,
    InputNumber,
    Menu,
    Dropdown,
    Divider
} from "antd";
import {message} from "../../../../../utils/message";
import SpacerBlock from "../../../../components/spacerBlock/SpacerBlock";
import {Prompt} from "react-router-dom";
import { DndProvider, DragSource, DropTarget} from 'react-dnd';
import  HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import "./MaintenanceField.css";
import attr_add from "../positionMaintenance/images/attr_add.png";
import attr_delete from "../positionMaintenance/images/attr_delete.png";
import {uuid} from "../../../../../utils";
import {getInfoFromLocalStorage} from "../../../../../actions";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../../../base/BaseComponent";
import PageTemplate from "../../../components/pageTemplate/PageTemplate";
import {getMaxWidth} from "../../../../newMediaMatrix/components/utils";
import BaseTable from "../../../components/TableTemplate/BaseTable";
import ShowRuleComponent from "./components/showRuleComponent";

const {TextArea} = Input;
const {Option} = Select;
const {confirm} = Modal;
let dragingIndex = -1;
const NewMediaFieldTypeEnum = [
    {
        key: 1,
        label: "文本框"
    },
    {
        key: 2,
        label: "文本域"
    },
    {
        key: 3,
        label: "单选下拉框"
    },
    {
        key: 4,
        label: "复选下拉框"
    },
    {
        key: 5,
        label: "日期选择器"
    },
    {
        key: 6,
        label: "危险处置人"
    },
    {
        key: 7,
        label: "媒体链接"
    },
    {
        key: 8,
        label: "备案表"
    },
    {
        key: 9,
        label: "附件上传"
    },
    {
        key: 10,
        label: "主责单位"
    },
    {
        key: 11,
        label: "确认框"
    },
    {
        key: 12,
        label: "用户选择框"
    }
];

class BodyRow extends React.Component {
    render() {
      const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
      const style = { ...restProps.style, cursor: 'move' };
  
      let { className } = restProps;
      if (isOver) {
        if (restProps.index > dragingIndex) {
          className += ' drop-over-downward';
        }
        if (restProps.index < dragingIndex) {
          className += ' drop-over-upward';
        }
      }
  
      return connectDragSource(
        connectDropTarget(<tr {...restProps} className={className} style={style} />),
      );
    }
  }

export default class MaintenanceField extends BaseComponent {
    constructor(props) {
        super(props);
        const typeId = props.match.params.id;
        this.state = {
            typeId,//平台id
            cancelPageStyle: props.cancelPageStyle || false,
            dataSource: [],//数据源
            dataSourceHold: [],//暂存数据
            dataSourceEdit: [],//编辑中的数据
            editingIds: [],//正在编辑的行
            addingIds: [],//添加中的行
            editPropertyVisible: false,//编辑属性弹框
            editPropertyId: "",
            editIds: [],//收集数据
            // 编辑属性弹窗的数据
            fieldName: "",
            fieldType: 1,    //字段类型
            ruleType: null,   //字段限制规则
            length: 0,
            limitContentId: "", //限制内容id
            keyValueMapsArr: [], //  键、值
            prohibitExit: false,
            platformName: "", //平台名称
            visible: false,
            regularRuleData: [],
            uploadCount: 1,
            col: 12,
            conditions: [],
            canEdit: true,
            confirmContent: ""
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.setState({
                typeId: this.props.match.params.id
            }, () => {
                this.getList();
            })
        }
    }

    componentDidMount() {
        this.getList();
        let params = getInfoFromLocalStorage("MaintenanceField");
        if (params) {
            this.state.platformName = params.name;
        }
        const observer = new ResizeObserver(e=>{
            e.forEach(entry=>{
                if (this.tableHeaderHeight !=  entry.target.offsetHeight) {
                    this.tableHeaderHeight =  entry.target.offsetHeight;
                    this.setState({});
                }
            });
        });
        const target = document.querySelector('.maintenanceField-table .ant-table-thead');
        target&&observer.observe(target)
        window.menuBlock.addMenuClick({path:window.location.hash,message:"\n检测到当前有操作没有保存，退出后当前修改数据将会丢失。\n\n是否强制退出！",isBlock:false});
    }

    componentWillUnmount() {
        window.menuBlock.destroy();
    }

    getColumns() {
        return ([
            {
                title: "字段名称",
                dataIndex: "fieldName",
                key: "fieldName",
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    if (isEditing) {
                        return (
                            <Form.Item>
                                <Input
                                    style={{
                                        background: "rgba(246, 248, 253, 0.86)",
                                        opacity: 1,
                                        transform: "translateY(10px)"
                                    }}
                                    value={currentEdit.fieldName}
                                    onChange={(e) => {
                                        currentEdit.fieldName = e.target.value.trim();
                                        this.setState({});
                                    }}
                                />
                            </Form.Item>);
                    } else {
                        return text;
                    }
                }
            },
            // {
            //     title: "键",
            //     dataIndex: "dbFieldName",
            //     key: "dbFieldName",
            //     render: (text, record) => {
            //         const isEditing = this.isEditing(record.id);
            //         const currentEdit = this.currentEditData(record);
            //         if (isEditing && currentEdit.defaultField) {
            //             return (
            //                 <Form.Item>
            //                     <Input
            //                         style={{
            //                             background: "rgba(246, 248, 253, 0.86)",
            //                             opacity: 1,
            //                             transform: "translateY(10px)"
            //                         }}
            //                         value={currentEdit.dbFieldName}
            //                         onChange={(e) => {
            //                             currentEdit.dbFieldName = e.target.value.trim();
            //                             this.setState({});
            //                         }}
            //                     />
            //                 </Form.Item>);
            //         } else {
            //             return text;
            //         }
            //     }
            // },
            {
                title: "类型",
                key: "fieldFillRulesFieldType",
                align: "center",
                render: (text, record) => {
                    let type;
                    try {
                        type = record.fieldType;
                    } catch (e) {
                        type = 0;
                    }
                    return this.parseType(type);
                }
            },
            {
                title: "字段提示",
                dataIndex: "fieldTip",
                key: "fieldTip",
                align: "center",
                ellipsis: true,
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    if (isEditing) {
                        return <TextArea
                            rows={1}
                            style={{background: "rgba(246, 248, 253, 0.86)", opacity: 1}}
                            value={currentEdit.fieldTip}
                            onChange={e => {
                                currentEdit.fieldTip = e.target.value.trim();
                                this.setState({});
                            }}
                        />;
                    } else {
                        return text;
                    }
                }
            },
            {
                title: "必填",
                dataIndex: "required",
                key: "required",
                align: "center",
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    return record.required === -1 ? null : <Switch
                        checkedChildren="是"
                        unCheckedChildren="否"
                        checked={isEditing ? currentEdit.required === 1 : record.required === 1}
                        disabled={!isEditing}
                        onChange={(checked) => {
                            currentEdit.required = checked ? 1 : 0;
                            this.setState({});
                        }}
                    />;
                }
            },
            {
                title: "必填提示",
                dataIndex: "requiredTip",
                key: "requiredTip",
                align: "center",
                ellipsis: true,
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    if (isEditing) {
                        return record.required === -1 ? null : <TextArea
                            rows={1}
                            style={{background: "rgba(246, 248, 253, 0.86)", opacity: 1}}
                            value={currentEdit.requiredTip}
                            onChange={e => {
                                currentEdit.requiredTip = e.target.value.trim();
                                this.setState({});
                            }}
                        />;
                    } else {
                        return text;
                    }
                }
            },
            {
                title: "开启状态",
                dataIndex: "status",
                key: "status",
                align: "center",
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    return <Switch
                        checkedChildren="开"
                        unCheckedChildren="关"
                        checked={isEditing ? currentEdit.status === 1 : record.status === 1}
                        disabled={!isEditing}
                        onChange={(checked) => {
                            currentEdit.status = checked ? 1 : 0;
                            this.setState({});
                        }}
                    />;
                }
            },
            {
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                width: 200,
                render: (text, record) => {
                    const editable = this.isEditing(record.id);
                    const showEditProperty = [6].includes(record.fieldType);
                    return editable ? (
                            <div className="operate_btns">
                                <span style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}
                                      onClick={() => this.saveEdit(record.id)}>确认</span>
                                <span style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}
                                      onClick={() => this.cancelEdit(record.id)}>取消</span>
                            </div>
                        ) :
                        (
                            <div className="operate_btns">
                                <span onClick={() => this.editRowHandle(record)}
                                      style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>编辑</span>
                                {!showEditProperty && <span onClick={() => this.editProperty(record)}
                                       style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>编辑属性</span>}
                                {
                                    record.defaultField ?
                                        <Popconfirm
                                            title="删除这行数据?"
                                            onConfirm={() => this.delCell(record.id, record)}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <span className="del">删除</span>
                                        </Popconfirm> : null}
                            </div>
                        );
                }
            }
        ])
    }

    handleMenuClick = ({key}) => {
        this.setState({
            visible: false,
            fieldType: parseInt(key)
        }, () => {
            this.addField();
        })
    }

    // 行是否正在编辑
    isEditing = (id) => {
        return this.inEditingIds(id) || this.inAddingIds(id);
    };

    // 编辑中的ids
    inEditingIds = (id) => this.state.editingIds.includes(id);

    // 添加中的ids
    inAddingIds = (id) => this.state.addingIds.includes(id);

    //点击添加按钮
    addField = () => {
        const {typeId, fieldType, col} = this.state;
        const id = uuid();
        const defaultLine = {
            id: id,
            fieldName: "字段名称",
            // dbFieldName: "键",
            fieldTip: "",
            required: 1,
            requiredTip: "",
            defaultField: 1,
            status: 1,
            fieldType,
            typeId,
            col,
            canEdit: true,
            fieldFillRules: [
                {
                    fieldType,
                    ruleType: 0,
                    length: 0,
                    uploadCount: 1,
                    limitContentId: "",
                    keyValueMaps: {},
                    confirmContent: ""
                }
            ]
        };
        this.state.dataSourceHold.push((JSON.parse(JSON.stringify(defaultLine))));
        this.state.dataSourceEdit.push((JSON.parse(JSON.stringify(defaultLine))));
        this.state.addingIds.push(id);
        this.setState({});
    };

    // 点击编辑
    editRowHandle(record) {
        this.state.editingIds.push(record.id);
        this.setState({});
    };

    getUrl(type) {
        let id = this.state.typeId;
        switch (type) {
            case "preEdit":
                return "/cm-sites-media-consumer/system/positionField/preEdit";
            case "preDelete":
                return "/cm-sites-media-consumer/system/positionField/preDelete";
            case "getListDataById":
                return "/cm-sites-media-consumer/system/positionField/getByPositionTypeId";
            case "recoverToDefault":
                return "/cm-sites-media-consumer/system/positionField/recoverToDefaultFields";
            case "batchDelete":
                return "/cm-sites-media-consumer/system/positionField//batchDelete";
            case "saveAll":
                return '/cm-sites-media-consumer/system/positionField/saveAll?typeId=' + id;
            default:
                return "";
        }
    }

    //保存属性类型
    saveProperty = (id) => {
        const {
            dataSourceEdit,
            dataSourceHold,
            fieldType,
            length,
            uploadCount,
            limitContentId,
            keyValueMapsArr,
            col,
            editIds,
            conditions,
            canEdit,
            confirmContent
        } = this.state;
        // 数据校验
        // // 键值对数据校验
        // for (let i = 0; i < keyValueMapsArr.length; i++) {
        //     const mapItem = keyValueMapsArr[i];
        //     if (!mapItem.value.trim() || !mapItem.key.trim()) {
        //         return message.warn("下拉框的键-值不能为空！");
        //     }
        // }

        const editItem = dataSourceEdit.find(item => item.id === id);

        this.request({
            url: this.getUrl("preEdit"),
            body: editItem,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    let fieldFillRule = [];
                    if (fieldType === 1 || fieldType === 2) {
                        let arrayRule = [];//字符数>0,限制内容也选了就有1 限制规则数组
                        if (length > 0) {
                            //小于0 不添加限制
                            arrayRule.push(0);
                        }
                        if (limitContentId) {
                            arrayRule.push(1);
                        }
                        arrayRule.forEach(itemRule => {
                            if (itemRule == 0 && length > 0) {
                                fieldFillRule.push({
                                    length,
                                    ruleType: 0,
                                    fieldType,
                                    keyValueMaps: {}
                                });
                            }
                            if (itemRule == 1) {
                                fieldFillRule.push({
                                    limitContentId,
                                    ruleType: 1,
                                    fieldType,
                                    keyValueMaps: {}
                                });
                            }
                        });
                    } else if (fieldType === 3) {
                        fieldFillRule = [{
                            fieldType,
                            ruleType: 2,
                            length: 0,
                            keyValueMaps: this.parseKeyValueMapsArr(keyValueMapsArr)
                        }];
                    } else if (fieldType === 4) {
                        fieldFillRule = [{
                            fieldType,
                            ruleType: 3,
                            length: 0,
                            keyValueMaps: this.parseKeyValueMapsArr(keyValueMapsArr)
                        }];
                    } else {
                        fieldFillRule = [{
                            fieldType,
                            ruleType: 4,
                            length: 0,
                            uploadCount,
                            keyValueMaps: {},
                            confirmContent
                        }];
                    }
                    editItem.fieldFillRules = fieldFillRule;
                    editItem.fieldType = fieldType;
                    editItem.col = col;
                    editItem.show = conditions;
                    editItem.canEdit = canEdit;
                    const holdIndex = dataSourceHold.findIndex(item => item.id === id);
                    dataSourceHold[holdIndex] = editItem;
                    dataSourceEdit[holdIndex] = editItem;
                    this.setState({
                        editIds: editIds.includes(id) ? [...editIds] : [...editIds, id],
                        editPropertyVisible: false,
                        editPropertyId: "",
                        fieldName: "",
                        fieldType: 1,
                        ruleType: 0,
                        length: 0,
                        uploadCount: 1,
                        limitContentId: "",
                        col: 12,
                        keyValueMapsArr: [],
                        canEdit: true,
                        confirmContent: "",
                        conditions: [],
                        prohibitExit: true
                    },()=>{
                        window.menuBlock.changeBlockStatus(window.location.hash,this.state.prohibitExit);
                    });
                }
            },
            errorCallBack: (e) => {
            },
        })
    };


    //编辑属性类型
    editProperty(record) {
        const {
            dataSourceEdit
        } = this.state;
        const current = dataSourceEdit.find(item => item.id === record.id);
        const {
            id,
            fieldName,
            fieldFillRules,
            col,
            canEdit
        } = current;
        let fieldType = 1, ruleType = [], length = 0, uploadCount = 1, keyValueMaps = {}, confirmContent = ""
        if (fieldFillRules?.[0]) {
            fieldType = fieldFillRules[0].fieldType
            ruleType = fieldFillRules[0].ruleType
            length = fieldFillRules[0].length
            uploadCount = fieldFillRules[0].uploadCount
            keyValueMaps = fieldFillRules[0].keyValueMaps
            confirmContent = fieldFillRules[0].confirmContent
        }else {
            fieldType = current.fieldType
        }
        let limitContentId = this.state.limitContentId;
        fieldFillRules && fieldFillRules.forEach(item => {
            if (item.ruleType === 1) {
                limitContentId = item.limitContentId;
            }
        });
        // 得到校验规则
        this.getRegularRuleData();
        this.setState({
            editPropertyVisible: true,
            editPropertyId: id,
            fieldName,
            fieldType,
            ruleType,
            length,
            uploadCount,
            limitContentId,
            col,
            conditions: current.show,
            canEdit,
            confirmContent,
            keyValueMapsArr: this.parseKeyValueMaps(keyValueMaps)
        });
    };

    getRegularRuleData() {
        this.request({
            url: '/cm-sites-media-consumer/system/regular/all',
            body: {},
            callBack: (data) => {
                let regularRuleData = [];
                if (data && data.length) {
                    regularRuleData = data.map(item => {
                        return {
                            key: item.id,
                            value: item.regularName
                        }
                    });
                }
                this.setState({
                    regularRuleData
                })
            },
            errorCallBack: (e) => {

            }
        })
    }

    //取消编辑属性
    cancelModal(id) {
        const {
            dataSourceEdit,
            dataSourceHold
        } = this.state;
        const editItemIndex = dataSourceEdit.findIndex(item => item.id === id);
        dataSourceEdit[editItemIndex] = JSON.parse(JSON.stringify(dataSourceHold.find(item => item.id === id)));
        this.setState({
            editPropertyVisible: false,
            editPropertyId: "",
            fieldName: "",
            fieldType: 1,
            ruleType: 0,
            length: 0,
            uploadCount: 1,
            limitContentId: "",
            col: 12,
            canEdit: true,
            confirmContent: "",
            keyValueMapsArr: []
        });
    };

    //保存编辑
    saveEdit = (id) => {
        const {
            dataSourceEdit,
            dataSourceHold,
            addingIds,
            editingIds,
            editIds
        } = this.state;
        const editItem = dataSourceEdit.find(item => item.id === id);
        if (!editItem.fieldName) {
            message.warn("字段名称不能为空");
            return false;
        }
        // else if (!editItem.dbFieldName) {
        //     message.warn("键不能为空");
        //     return false;
        // }
        this.request({
            url: this.getUrl("preEdit"),
            body: editItem,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    const holdItemIndex = dataSourceHold.findIndex(item => item.id === id);
                    dataSourceHold[holdItemIndex] = JSON.parse(JSON.stringify(editItem));
                    this.setState({
                        addingIds: addingIds.filter(item => item !== id),
                        editingIds: editingIds.filter(item => item !== id),
                        editIds: editIds.includes(id) ? [...editIds] : [...editIds, id],
                        prohibitExit: true
                    },()=>{
                        // 修改路由拦截状态
                        window.menuBlock.changeBlockStatus(window.location.hash,this.state.prohibitExit);
                    });
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    //取消编辑
    cancelEdit = (id) => {
        // 通过暂存数据  复原编辑数据
        // 删除 editingIds addingIds 中的id
        let {
            dataSourceEdit,
            dataSourceHold,
            addingIds,
            editingIds
        } = this.state;
        if (this.inAddingIds(id)) {
            // 如果是添加  直接删除
            this.setState({
                dataSourceEdit: dataSourceEdit.filter(item => item.id !== id),
                dataSourceHold: dataSourceHold.filter(item => item.id !== id),
                addingIds: addingIds.filter(item => item !== id)
            });
        } else {
            const editItemIndex = dataSourceEdit.findIndex(item => item.id === id);
            dataSourceEdit[editItemIndex] = JSON.parse(JSON.stringify(dataSourceHold.find(item => item.id === id)));
            this.setState({
                editingIds: editingIds.filter(item => item !== id)
            });
        }
    };

    //删除行
    delCell = (id, record) => {
        const {typeId} = this.state;
        //删除前置接口  判断是否允许删除
        this.request({
            url: this.getUrl("preDelete"),
            body: {positionFieldDefineId: id, typeId},
            callBack: (res) => {
                if (res) {
                    // 删除行 删除暂存和编辑里面的行
                    let {
                        dataSourceEdit,
                        dataSourceHold
                    } = this.state;
                    this.setState({
                        dataSourceEdit: dataSourceEdit.filter(item => item.id !== id),
                        dataSourceHold: dataSourceHold.filter(item => item.id !== id),
                        prohibitExit: true
                    },()=>{
                        this.deleteRules(record);
                        window.menuBlock.changeBlockStatus(window.location.hash,this.state.prohibitExit);
                    });
                }
            },
            errorCallBack: (e) => {
                message.warn(e);
            },
            serverVerify: {
                serverErrorCallBack: (e) => {
                    message.warn(e);
                },
                isShowErrorMsg: false
            }
        })
    };

    deleteRules = (record) => {
        let {dataSourceHold} = this.state;
        dataSourceHold && dataSourceHold.length && dataSourceHold.forEach(item => {
            if(item?.show && item.show.some(i => i?.field?.key === record?.dbFieldName)) {
                item.show = null;
            }
        })
        this.setState({dataSourceHold})
    }

    //解析类型
    parseType = (type) => {
        let typeString = "";
        for (let i = 0; i < NewMediaFieldTypeEnum.length; i++) {
            const item = NewMediaFieldTypeEnum[i];
            if (item.key === type) {
                typeString = item.label;
                break;
            }
        }
        return typeString;
    };

    //获取数据
    getList() {
        const {typeId} = this.state;
        this.request({
            url: this.getUrl("getListDataById"),
            body: {typeId},
            callBack: (data) => {
                const dataJSON = JSON.stringify(data);
                this.setState({
                    dataSource: JSON.parse(dataJSON),
                    dataSourceHold: JSON.parse(dataJSON),//暂存数据
                    dataSourceEdit: JSON.parse(dataJSON)//正在编辑数据
                });
            },
            errorCallBack: (e) => {
            },
        })
    }

    //当前的编辑属性
    currentEditData = (record) => {
        const id = record.id;
        const {dataSourceEdit} = this.state;
        for (let i = 0; i < dataSourceEdit.length; i++) {
            const item = dataSourceEdit[i];
            if (id === item.id) {
                return item;
            }
        }
    };

    //返回
    goBack() {
        const {
            editingIds,
            addingIds
        } = this.state;
        if (editingIds.length || addingIds.length) {
            console.log("当前表格正在编辑");
        }
        window.location.hash = "/newMedia/positionMaintenance";
    };

    //恢复数据
    //自定义的删掉
    // 所有内置字段还原
    restoreData() {
        const {typeId} = this.state;
        confirm({
            title: "是否恢复默认？",
            content: "数据即将恢复到默认配置，自定义字段数据将被删除，内置字段数据将被还原",
            onOk: () => {
                this.setState({
                    editingIds: [],
                    addingIds: [],
                    editPropertyVisible: false,
                    editPropertyId: "",
                    editIds: [],
                    fieldName: "",
                    fieldType: 1,
                    ruleType: 0,
                    length: 0,
                    uploadCount: 1,
                    limitContentId: "",
                    col: 12,
                    canEdit: true,
                    confirmContent: "",
                    keyValueMapsArr: [],
                    prohibitExit: false
                },()=>{
                    window.menuBlock.changeBlockStatus(window.location.hash,this.state.prohibitExit);
                });
                this.request({
                    url: this.getUrl("recoverToDefault"),
                    body: {typeId},
                    callBack: (data) => {
                        message.success("数据已恢复");
                        this.getList();
                    },
                    errorCallBack: (e) => {
                    },
                })
            },
            cancelText: "取消",
            okText: "确认"
        });
    };

    // 保存所有
    saveAll() {
        let {
            dataSourceHold,
            dataSource,
            editingIds,
            addingIds,
            typeId
        } = this.state;

        if (editingIds.length || addingIds.length) {
            message.warn("当前存在数据正在编辑，请完成后再保存！");
            return false;
        }

        // 数据校验  校验 dataSourceHold
        for (let i = 0; i < dataSourceHold.length; i++) {
            const holdItem = dataSourceHold[i];
            if (holdItem.fieldName === "") {
                message.warn("字段名称不能为空，添加字段名称后再保存");
                return false;
            }
            // else if (holdItem.dbFieldName === "") {
            //     message.warn("键不能为空，添加字段名称后再保存");
            //     return false;
            // }
            for (let j = i + 1; j < dataSourceHold.length; j++) {
                const holdItemJ = dataSourceHold[j];
                if (holdItemJ.fieldName === holdItem.fieldName) {
                    message.warn("字段名称不能重复，重复字段名称：" + holdItem.fieldName);
                    return false;
                }
                // else if (holdItemJ.dbFieldName === holdItem.dbFieldName) {
                //     message.warn("键不能重复，重复键名称：" + holdItem.dbFieldName);
                //     return false;
                // }
            }
        }
        // 获取删除数据
        const delIds = [];
        dataSource.forEach(sourceItem => {
            const holdItemIndex = dataSourceHold.findIndex(holeItem => holeItem.id === sourceItem.id);
            if (holdItemIndex === -1) {
                delIds.push(sourceItem.id);
            }
        });

        // 批量删除
        if (delIds.length) {
            this.request({
                url: this.getUrl("batchDelete"),
                body: {
                    positionFieldDefineIds: delIds,
                    typeId
                },
                callBack: (data) => {
                    message.success("保存成功");
                    this.getList();
                },
                errorCallBack: (e) => {
                },
            })
        }

        // 保存所有
        if (!dataSourceHold.length && !delIds.length) {
            this.setState({prohibitExit: false},()=>{
                window.menuBlock.changeBlockStatus(window.location.hash,this.state.prohibitExit);
            });
            message.warn("当前没有数据可保存");
            return false;
        }
        if (dataSourceHold.length) {
            this.request({
                url: this.getUrl("saveAll"),
                body: dataSourceHold,
                method: "post",
                contentType: "json",
                callBack: (data) => {
                    message.success("保存成功");
                    this.getList();
                },
                errorCallBack: (e) => {
                },
            })
        }
        this.setState({prohibitExit: false},()=>{
            window.menuBlock.changeBlockStatus(window.location.hash,this.state.prohibitExit);
        });
    };

    // keyValueMaps to array
    parseKeyValueMaps = (maps) => {
        const arr = [];
        Object.keys(maps).forEach(item => {
            arr.push({
                key: item,
                value: maps[item],
                id: Math.random()
            });
        });
        return arr;
    };

    // KeyValueMapsArr to map
    parseKeyValueMapsArr = (arr) => {
        const obj = {};
        arr.forEach(item => {
            obj[item.key] = item.value;
        });
        return obj;
    };

    renderTop() {
        return (
            <div style={{padding: 20, background: "#fff"}}>
                <div style={{
                    padding: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <div style={{fontSize: 16, color: "#222"}}>平台维护-{this.state.platformName}</div>
                    <div>当前位置： 平台维护
                        <span style={{margin: "0px 6px"}}>{">"}</span>
                        <span
                            style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}> 维护字段</span>
                        <span style={{margin: "0px 10px"}}>|</span>
                        <span
                            onClick={() => {
                                window.location.hash = "/newMedia/positionMaintenance";
                            }}
                            style={{
                                color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                cursor: "pointer"
                            }}>
                            返回上一级
                        </span>
                    </div>
                </div>
                <SpacerBlock height={1}/>
            </div>
        )
    }

    components = {
        body: {
            row: DragableBodyRow,
        }
    }

    searchHeight = 85; // 搜索区高度
    tableHeaderHeight = 0; // 表头高度
    pageMargin = 15;  // 页面margin
    pagePadding = 0; // 页面padding
    tabsHeight = 0; // tab栏高度
    paginationHeight = 0; // 分页器高度
    addBtnHeight = 43; // 添加按钮高度
    bottomBtnHeight = 63; // 底部按钮高度
    tableTopPadding = 0; //table顶部边距
    tableBottomPadding = 20; //table底部边距
    topMenuHeight = 70; //顶部菜单高度
    otherHeight = this.searchHeight + this.tableHeaderHeight + this.pageMargin * 2 + this.pagePadding * 2 + this.tabsHeight + this.paginationHeight + this.addBtnHeight + this.bottomBtnHeight + this.tableTopPadding + this.tableBottomPadding + this.topMenuHeight; // 除表格外的其他所有高度集合
    tableHeight = `calc(100vh - ${this.otherHeight + "px"})`;

    renderTable() {
        const columns = this.getColumns();
        const {tabKey = 'maintenanceField', dataSourceHold} = this.state;
        let maintenanceFieldTableColor = this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3");
        return (
            <>
                <Scrollbars autoHeight autoHeightMax={this.tableHeight}>
                    <DndProvider backend={HTML5Backend}>
                        <div className="maintenanceField-table">
                            <BaseTable
                                key={"TableTemplate" + tabKey}
                                maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                                maxHeight={this.tableHeight}
                                columns={columns}
                                pagination={false}
                                components={this.components}
                                onRow={(record, index) => {
                                    return {
                                        index,
                                        moveRow: this.moveRow.bind(this),
                                        isEditing: this.isEditing(record.id)
                                    }
                                }}
                                dataSource={dataSourceHold}
                                onResize={(offsetHeight) => {
                                    if (this.tableHeaderHeight != offsetHeight) {
                                        this.tableHeaderHeight = offsetHeight;
                                        this.setState({});
                                    }
                                }}
                                rowClassName={(record, index) => {
                                    return this.isEditing(record.id) ? "editing-row" : "";
                                }}
                            />
                            <style>
                                {
                                    `
                                    .maintenanceField-table tr.drop-over-downward td {
                                        border-bottom: 2px dashed ${maintenanceFieldTableColor};
                                    }
                                    
                                    .maintenanceField-table tr.drop-over-upward td {
                                        border-top: 2px dashed ${maintenanceFieldTableColor};
                                    }
                                    `
                                }
                            </style>
                        </div>
                    </DndProvider>
                </Scrollbars>
            </>
        )
    }

    // 表格行移动方法
    moveRow(dragIndex, hoverIndex) {
        const { dataSourceHold } = this.state;
        const dragRow = dataSourceHold[dragIndex];
        dragRow.order = hoverIndex;
        this.setState(update(this.state,{
            dataSourceHold: {
                $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
                $apply: (arr)=>arr.map((item,index)=>{
                    return {
                        ...item,
                        order: index,
                    }
                })
            }
        }))
    }

    renderAdd() {
        const menu = (
            <Menu onClick={this.handleMenuClick} onMouseLeave={() => {
                this.setState({visible: false})
            }}>
                <Menu.Item key={1}>文本框</Menu.Item>
                <Menu.Item key={2}>文本域</Menu.Item>
                <Menu.Item key={3}>单选下拉框</Menu.Item>
                <Menu.Item key={4}>复选下拉框</Menu.Item>
                <Menu.Item key={5}>日期选择器</Menu.Item>
                <Menu.Item key={9}>附件上传</Menu.Item>
                <Menu.Item key={11}>确认框</Menu.Item>
                <Menu.Item key={12}>用户选择框</Menu.Item>
            </Menu>
        );
        return (
            <Dropdown overlayClassName={"dropDown"} trigger={["click"]} overlay={menu} placement="bottomCenter"
                      onVisibleChange={(flag) => {
                          this.setState({visible: flag});
                      }}
                      visible={this.state.visible}
            >
                <div onClick={(e) => {
                    e.preventDefault();
                }} style={{
                    textAlign: "center",
                    width: "100%",
                    border: "1px dashed #ccc",
                    padding: "5px 0px",
                    cursor: "pointer",
                    marginTop: "8px"
                }}>
                    <Icon style={{marginRight: "10px", fontSize: 10}} type={"plus"}/>添加
                </div>
            </Dropdown>
        )
    }

    renderEditAttrModal() {
        let {
            fieldName,
            fieldType,
            length,
            uploadCount,
            limitContentId,
            keyValueMapsArr,
            editPropertyVisible,
            editPropertyId,
            regularRuleData,
            col,
            conditions,
            dataSourceEdit,
            canEdit,
            confirmContent
        } = this.state;
        const editItem = dataSourceEdit.find(item => item.id === editPropertyId);
        let showRules = editItem?.defaultField || false;
        return (
            <Modal
                title="编辑属性"
                visible={editPropertyVisible}
                onCancel={() => this.cancelModal(editPropertyId)}
                onOk={() => this.saveProperty(editPropertyId)}
                centered={true}
                width={750}
                className="field_modal"
            >
                <Scrollbars autoHide autoHeight autoHeightMax={630}>
                    <Form labelCol={{span: 3}} wrapperCol={{span: 19}}>
                        <Form.Item label="字段名称">
                            <div>{fieldName}</div>
                        </Form.Item>
                        <Form.Item label="字段类型" required>
                            <Input placeholder={this.parseType(fieldType)} disabled={true}
                                   style={{border: "none"}}></Input>
                        </Form.Item>
                        {
                            //文本框和文本域
                            fieldType === 1 || fieldType === 2 ?
                                <>
                                    <Form.Item label="限制字符数">
                                        <InputNumber
                                            precision={1}
                                            min={0}
                                            step={1}
                                            formatter={v => isNaN(v) ? 0 : v * 1}
                                            value={length}
                                            onChange={e => this.setState({length: e || 0})}
                                        />
                                        <span>填写"0"则为不限制</span>
                                    </Form.Item>
                                    <Form.Item label="限制内容">
                                        <Select
                                            placeholder="请选择"
                                            value={limitContentId || undefined}
                                            onChange={value => {
                                                this.setState({limitContentId: value});
                                            }
                                            }
                                        >
                                            {regularRuleData.map(item => <Option value={item.key}
                                                                         key={item.key}>{item.value}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </> :
                                fieldType === 3 || fieldType === 4 ?
                                    <ul className="property_list_wrap">
                                        <li className="property_list_item" id="property_list_itemOne">
                                            {/*<span>键</span>*/}
                                            <span>值</span>
                                            <div>
                                                <img src={attr_add}
                                                     onClick={() => this.setState({
                                                         keyValueMapsArr: [...keyValueMapsArr, {
                                                             key: uuid(),
                                                             value: "",
                                                             id: Math.random()
                                                         }]
                                                     })}
                                                />
                                            </div>
                                        </li>
                                        {
                                            keyValueMapsArr.map(item => {
                                                return <li className="property_list_item"
                                                           key={item.id}>
                                                    {/*<Input*/}
                                                    {/*    placeholder="请输入"*/}
                                                    {/*    value={item.key}*/}
                                                    {/*    onChange={(e) => {*/}
                                                    {/*        item.key = e.target.value;*/}
                                                    {/*        this.setState({});*/}
                                                    {/*    }}/>*/}
                                                    <Input
                                                        placeholder="请输入"
                                                        value={item.value}
                                                        onChange={(e) => {
                                                            item.value = e.target.value;
                                                            this.setState({});
                                                        }}/>
                                                    <div style={{marginTop: 3}}>
                                                        <img src={attr_delete} onClick={() => {
                                                            this.setState({
                                                                keyValueMapsArr: keyValueMapsArr.filter(prop => {
                                                                    return item.id !== prop.id;
                                                                })
                                                            });
                                                        }}/>
                                                    </div>
                                                </li>;
                                            })
                                        }
                                    </ul> :
                                    fieldType === 9 ?
                                    <>
                                        <Form.Item label="限制上传数">
                                            <InputNumber
                                                precision={1}
                                                min={0}
                                                step={1}
                                                formatter={v => isNaN(v) ? 0 : v * 1}
                                                value={uploadCount}
                                                onChange={e => this.setState({uploadCount: e || 0})}
                                            />
                                            <span>填写"0"则为不限制</span>
                                        </Form.Item>
                                    </> : <></>
                        }
                        <Form.Item label="占据行宽">
                            <Select
                                placeholder="请选择"
                                value={col || undefined}
                                onChange={value => {
                                    this.setState({col: value});
                                }
                                }
                                style={{width: 100}}
                            >
                                <Option value={12} key={"一列"}>一列</Option>
                                <Option value={24} key={"两列"}>两列</Option>
                            </Select>
                        </Form.Item>
                        {showRules && <Form.Item label="显示规则" className={"showRules"}>
                            <ShowRuleComponent
                                fieldName={fieldName}
                                dataSourceHold={this.state.dataSourceHold.filter(item => item.id !== editPropertyId)}
                                conditions={conditions}
                                onOk={(conditions) => {
                                    this.setState({conditions});
                                }}
                            />
                        </Form.Item>}
                        {fieldType === 10 && <Form.Item label="禁止编辑">
                            <Switch checked={!canEdit} onChange={(checked) => {
                                this.setState({canEdit: !checked})
                            }} />
                        </Form.Item>}
                        {fieldType === 11 && <Form.Item label="确认内容">
                            <TextArea
                                rows={2}
                                style={{background: "rgba(246, 248, 253, 0.86)", opacity: 1}}
                                value={confirmContent}
                                onChange={(e) => {
                                this.setState({confirmContent: e.target.value})
                            }} />
                        </Form.Item>}
                        <style>{`.showRules .ant-form-item-control {line-height: 20px !important; margin-top: 10px;}`}</style>
                    </Form>
                </Scrollbars>
            </Modal>
        )
    }

    renderBtn() {
        return (
            <div id={"mainteranceField"} style={{backgroundColor: "#fff"}}>
                <Divider/>
                <div style={{justifyContent: "center", display: "flex", alignItems: "center", paddingBottom: 15}}>
                    <Button onClick={() => this.goBack()}>返回</Button>
                    <Button onClick={() => this.restoreData()}>恢复默认</Button>
                    <Button onClick={() => this.saveAll()} type="primary">保存</Button>
                </div>
                <style>{`
                    #mainteranceField .ant-divider-horizontal{margin: 0px 0px 15px 0px !important;}
                    #mainteranceField button{margin: 0 10px;}
                `}</style>
            </div>
        )
    }

    render() {
        return (
            <PageTemplate style={{padding: this.state.cancelPageStyle ? 0 : ""}}
                          styleOut={{margin: this.state.cancelPageStyle ? 0 : ""}}>
                {/* <Prompt when={this.state.prohibitExit}
                        message={() => "\n检测到当前有操作没有保存，退出后当前修改数据将会丢失。\n\n是否强制退出！"}/> */}
                {this.renderTop()}
                <div id="user_custom_table">
                    {this.renderTable()}
                    {this.renderAdd()}
                    {this.renderEditAttrModal()}
                </div>
                {this.renderBtn()}
            </PageTemplate>
        );
    }
}

const rowTarget = {
    drop(props, monitor) {
      const dragIndex = monitor.getItem().index;
      const hoverIndex = props.index;
  
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
  
      // Time to actually perform the action
      props.moveRow(dragIndex, hoverIndex);
  
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      monitor.getItem().index = hoverIndex;
    },
  }

  const rowSource = {
    beginDrag(props) {
      dragingIndex = props.index;
      return {
        index: props.index,
      };
    },
    canDrag(props) {
        console.log("🚀 ~ canDrag ~ props:", props)
        return !props.isEditing;
    }
  };

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))(
    DragSource('row', rowSource, connect => ({
        connectDragSource: connect.dragSource(),
    }))(BodyRow),
);
